if (!customElements.get('myakm-safari-ai-guide')) {
  customElements.define('myakm-safari-ai-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const field = this.querySelector('[data-ai-prompt]');
      const button = this.querySelector('[data-copy-prompt]');
      const status = this.querySelector('[data-copy-status]');
      if (!field || !button || !status) return;
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(field.value);
          if (this.isConnected) status.textContent = this.dataset.copySuccess;
        } catch {
          if (!this.isConnected) return;
          field.focus();
          field.select();
          status.textContent = this.dataset.copyFallback;
        }
      }, { signal: this.controller.signal });
      const panel = this.querySelector('[data-car-send-panel]');
      if (!panel) return;
      const ad = panel.querySelector('[data-car-ad]');
      const send = panel.querySelector('[data-send-car-ad]');
      const sendStatus = panel.querySelector('[data-car-send-status]');
      const base = panel.dataset.whatsappBase;
      if (!ad || !send || !sendStatus || !/^https:\/\/wa\.me\/[1-9]\d{7,14}$/.test(base)) return;
      const update = () => {
        const text = ad.value.trim();
        const valid = text.length >= 20;
        send.setAttribute('aria-disabled', String(!valid));
        send.href = valid ? base + '?text=' + encodeURIComponent(panel.dataset.messageIntro + '\n\n' + text) : base;
        sendStatus.textContent = '';
        return valid;
      };
      ad.addEventListener('input', update, { signal: this.controller.signal });
      send.addEventListener('click', event => {
        if (!update()) {
          event.preventDefault();
          sendStatus.textContent = panel.dataset.emptyMessage;
          ad.focus();
        }
      }, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

